module.exports = __webpack_public_path__ + "static/7a-3f586f5c16f5a5c87a0e8ebdf1782ae7.png";